import { AppModule } from './lib/app-module';
import { Slide, SlideConfig } from './modules/slide';
import { NavHandler, NavHandlerConfig } from './modules/nav';
import { MailchimpSubscribe, MailchimpSubscribeConfig } from './modules/mailchimp';
import { TabPages, TabPagesConfig } from './modules/tab-pages';
import { Tracker, TrackerConfig } from './modules/tracker';
import { PostLoader, PostLoaderConfig } from './modules/post-loader';
import { UserModule } from './modules/user/user';
import { Modal, ModalConfig } from './modules/modal';
import { Stripe } from './modules/stripe';
import { ContactConfig, ContactForm } from './modules/contact';
import { Utilities, utilities } from './lib/utilities';
import { Filter, FilterConfig } from './modules/filter';

type ModuleName = 'nav' | 'slide' | 'tracker' | 'mc' | 'tabs' | 'posts' | 'user' | 'modal' | 'stripe' | 'contact' | 'filter'
interface ModuleDescriptor<Name extends ModuleName, Config> {
    n: Name;
    c: Config
}
type Module = 
    | ModuleDescriptor<'nav', NavHandlerConfig>
    | ModuleDescriptor<'tracker', TrackerConfig>
    | ModuleDescriptor<'slide', SlideConfig>
    | ModuleDescriptor<'mc', MailchimpSubscribeConfig>
    | ModuleDescriptor<'tabs', TabPagesConfig>
    | ModuleDescriptor<'posts', PostLoaderConfig>
    | ModuleDescriptor<'user', undefined>
    | ModuleDescriptor<'modal', ModalConfig>
    | ModuleDescriptor<'stripe', undefined>
    | ModuleDescriptor<'contact', ContactConfig>
    | ModuleDescriptor<'filter', FilterConfig>

interface AppConfig {
    modules: Module[];
}

type ModuleExports = {[module in ModuleName]?: unknown};

const moduleExports: ModuleExports = {};

const loadModule = (name: ModuleName, module: AppModule<unknown, unknown>): void => {
    module.load();
    const modExport = module.export;
    if (modExport !== undefined) {
        moduleExports[name] = modExport;
    }
};

const init = (config: AppConfig): void  => {
    // eslint-disable-next-line complexity
    config.modules.forEach(({n, c})  => {
        switch (n) {
        case 'nav':
            return loadModule(n, new NavHandler(c));
        case 'tracker':
            return loadModule(n, new Tracker(c));
        case 'tabs':
            return loadModule(n, new TabPages(c));
        case 'slide':
            return loadModule(n, new Slide(c));
        case 'mc':
            return loadModule(n, new MailchimpSubscribe(c));
        case 'posts':
            return loadModule(n, new PostLoader(c));
        case 'user':
            return loadModule(n, new UserModule(c));
        case 'modal':
            return loadModule(n, new Modal(c));
        case 'stripe':
            return loadModule(n, new Stripe(c));
        case 'contact':
            return loadModule(n, new ContactForm(c));
        case 'filter':
            return loadModule(n, new Filter(c));
        default:
            console.log(`unknown module ${n}`);
        }
    });
};

export interface App {
    init: typeof init,
    m: ModuleExports,
    u: Utilities
}

export {init, moduleExports as m, utilities as u};

